// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workspace-resource-panel,
.workspace-agent-policy-panel,
.workspace-approval-card {
  box-sizing: border-box;
  width: 100%;
  margin: 1.25rem 0;
  padding: 1rem;
  border: 1px solid var(--border-color);
  border-radius: var(--radius);
  background: var(--background-color);
  color: var(--text-color);
  container-type: inline-size;
  container-name: workspaceCard;
}

.workspace-resource-panel-header,
.workspace-approval-header,
.workspace-range-heading,
.workspace-quote-total,
.workspace-resource-readout {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.workspace-resource-panel h3,
.workspace-agent-policy-panel h3,
.workspace-approval-card h3 {
  margin: 0;
}

.workspace-resource-panel p,
.workspace-resource-panel small,
.workspace-agent-policy-panel p,
.workspace-agent-policy-panel small {
  color: var(--secondary-text-color);
}

.workspace-agent-policy-header p {
  margin: 0.25rem 0 0;
  font-size: 0.875rem;
}

.workspace-agent-limit-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-color);
}

.workspace-agent-limit-row > span,
.workspace-agent-limit-row small {
  display: block;
}

.workspace-agent-limit-row small {
  margin-top: 0.2rem;
  font-size: 0.8rem;
}

.workspace-agent-limit-row input {
  width: 5rem;
  flex: 0 0 auto;
}

.workspace-resource-panel-header p {
  margin: 0.25rem 0 0;
  font-size: 0.875rem;
}

.workspace-provider-badge,
.workspace-request-status {
  flex: 0 0 auto;
  padding: 0.2rem 0.5rem;
  border: 1px solid var(--border-color);
  border-radius: 999px;
  color: var(--secondary-text-color);
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: capitalize;
}

.workspace-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin: 1rem 0;
}

.workspace-toggle-row > span,
.workspace-toggle-row small {
  display: block;
}

.workspace-toggle-row small {
  margin-top: 0.2rem;
  color: var(--secondary-text-color);
  font-size: 0.8rem;
}

.workspace-toggle-row input[type='checkbox'] {
  width: 1.1rem;
  height: 1.1rem;
  margin: 0;
}

.workspace-range-matrix {
  border-top: 1px solid var(--border-color);
}

.workspace-range-row,
.workspace-gpu-row,
.workspace-request-options,
.workspace-resource-readout {
  padding: 0.75rem 0;
  border-bottom: 1px solid var(--border-color);
}

.workspace-range-row {
  display: grid;
  grid-template-columns: minmax(10rem, 0.42fr) minmax(12rem, 1fr);
  align-items: center;
  gap: 1rem;
  min-width: 0;
}

.workspace-range-row > * {
  min-width: 0;
}

/* Native range inputs have a browser-default preferred width that ignores
   the grid track's percentage sizing, which overflows the card at dock
   width (~360-380px). Force it to fill and shrink with its column. */
.workspace-approval-card input[type='range'] {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  min-width: 0;
}

.workspace-range-heading label,
.workspace-range-heading output {
  margin: 0;
  font-size: 0.875rem;
}

.workspace-range-heading output,
.workspace-resource-readout strong,
.workspace-quote dd {
  font-variant-numeric: tabular-nums;
}

.workspace-range-row input[type='range'] {
  min-height: 1.5rem;
  padding: 0;
  accent-color: var(--button-primary-bg);
  background: transparent;
}

.workspace-gpu-row {
  display: grid;
  grid-template-columns: minmax(10rem, 1fr) auto;
  align-items: center;
  gap: 1rem;
}

.workspace-toggle-row-compact {
  margin: 0;
}

.workspace-stepper,
.workspace-select-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin: 0;
  font-size: 0.875rem;
}

.workspace-stepper input {
  width: 5rem;
}

.workspace-select-row select {
  width: auto;
  min-width: 10rem;
}

.workspace-request-options {
  display: grid;
  gap: 0.75rem;
}

.workspace-approval-eyebrow {
  display: block;
  margin-bottom: 0.2rem;
  color: var(--secondary-text-color);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.workspace-quote {
  margin-top: 1rem;
  padding: 0.75rem;
  border-radius: var(--radius-sm);
  background: var(--card-background);
}

.workspace-quote-total strong {
  font-size: 0.9rem;
}

.workspace-quote dl {
  display: grid;
  gap: 0.25rem;
  margin: 0.6rem 0 0;
}

.workspace-quote dl div {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  color: var(--secondary-text-color);
  font-size: 0.8rem;
}

.workspace-quote dt {
  text-transform: capitalize;
}

.workspace-quote dd {
  margin: 0;
}

.workspace-idle-note,
.workspace-save-note,
.workspace-resource-notice,
.workspace-resource-error {
  margin: 0.75rem 0 0;
  color: var(--secondary-text-color);
  font-size: 0.8rem;
}

.workspace-resource-error {
  color: #b00020;
}

.workspace-approval-card .workspace-resource-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.workspace-approval-card .workspace-retry-button {
  width: auto;
  margin: 0;
  flex: 0 0 auto;
}

.workspace-approval-actions,
.workspace-summary-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem;
}

.workspace-approval-actions button,
.workspace-summary-actions button {
  width: auto;
  margin: 0;
}

.workspace-summary-line {
  margin: 0.75rem 0 0;
  font-size: 0.9rem;
  font-variant-numeric: tabular-nums;
}

.workspace-back-button {
  width: auto;
  margin: 0 0 0.75rem;
}

.workspace-resource-panel :focus-visible,
.workspace-approval-card :focus-visible {
  outline: 3px solid rgba(37, 99, 235, 0.35);
  outline-offset: 2px;
}

@media (max-width: 600px) {
  .workspace-range-row {
    grid-template-columns: 1fr;
    gap: 0.4rem;
  }

  .workspace-gpu-row {
    grid-template-columns: 1fr;
  }

  .workspace-approval-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .workspace-approval-actions button {
    width: 100%;
  }
}

/* The viewport-based breakpoint above never fires when this card is embedded
   narrow (e.g. the ~360px chat dock) inside a wide window. A container query
   collapses the two-column rows based on the CARD's own width instead, so
   the range inputs and option rows never overflow it regardless of the
   surrounding viewport. */
@container workspaceCard (max-width: 420px) {
  .workspace-range-row,
  .workspace-range-matrix .workspace-range-row {
    grid-template-columns: 1fr;
    gap: 0.4rem;
  }

  .workspace-gpu-row {
    grid-template-columns: 1fr;
  }

  .workspace-request-options {
    grid-template-columns: 1fr;
  }

  .workspace-stepper,
  .workspace-select-row {
    flex-wrap: wrap;
  }

  .workspace-select-row select {
    width: 100%;
    min-width: 0;
  }

  .workspace-stepper input {
    width: 100%;
  }

  .workspace-approval-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .workspace-approval-actions button {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .workspace-resource-panel *,
  .workspace-approval-card * {
    scroll-behavior: auto;
    transition-duration: 0.01ms !important;
  }
}
.workspace-decision-note {
  display: grid;
  gap: 5px;
  margin-top: 14px;
  font-size: 0.8rem;
  font-weight: 600;
}
.workspace-decision-note textarea {
  min-height: 62px;
  resize: vertical;
  border: 1px solid var(--border-color, #ccc);
  border-radius: 7px;
  padding: 8px;
  color: inherit;
  background: var(--input-bg, transparent);
}
`, "",{"version":3,"sources":["webpack://./src/workspaces/workspace-resources.css"],"names":[],"mappings":"AAAA;;;EAGE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,qCAAqC;EACrC,4BAA4B;EAC5B,mCAAmC;EACnC,wBAAwB;EACxB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;;EAGE,SAAS;AACX;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,qCAAqC;EACrC,oBAAoB;EACpB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,SAAS;AACX;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;;;EAIE,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,+DAA+D;EAC/D,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;qEAEqE;AACrE;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kCAAkC;EAClC,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA;;;;EAIE,mBAAmB;EACnB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;;;0BAI0B;AAC1B;EACE;;IAEE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,qBAAqB;IACrB,sCAAsC;EACxC;AACF;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,wCAAwC;AAC1C","sourcesContent":[".workspace-resource-panel,\n.workspace-agent-policy-panel,\n.workspace-approval-card {\n  box-sizing: border-box;\n  width: 100%;\n  margin: 1.25rem 0;\n  padding: 1rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius);\n  background: var(--background-color);\n  color: var(--text-color);\n  container-type: inline-size;\n  container-name: workspaceCard;\n}\n\n.workspace-resource-panel-header,\n.workspace-approval-header,\n.workspace-range-heading,\n.workspace-quote-total,\n.workspace-resource-readout {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.workspace-resource-panel h3,\n.workspace-agent-policy-panel h3,\n.workspace-approval-card h3 {\n  margin: 0;\n}\n\n.workspace-resource-panel p,\n.workspace-resource-panel small,\n.workspace-agent-policy-panel p,\n.workspace-agent-policy-panel small {\n  color: var(--secondary-text-color);\n}\n\n.workspace-agent-policy-header p {\n  margin: 0.25rem 0 0;\n  font-size: 0.875rem;\n}\n\n.workspace-agent-limit-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border-color);\n}\n\n.workspace-agent-limit-row > span,\n.workspace-agent-limit-row small {\n  display: block;\n}\n\n.workspace-agent-limit-row small {\n  margin-top: 0.2rem;\n  font-size: 0.8rem;\n}\n\n.workspace-agent-limit-row input {\n  width: 5rem;\n  flex: 0 0 auto;\n}\n\n.workspace-resource-panel-header p {\n  margin: 0.25rem 0 0;\n  font-size: 0.875rem;\n}\n\n.workspace-provider-badge,\n.workspace-request-status {\n  flex: 0 0 auto;\n  padding: 0.2rem 0.5rem;\n  border: 1px solid var(--border-color);\n  border-radius: 999px;\n  color: var(--secondary-text-color);\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: capitalize;\n}\n\n.workspace-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin: 1rem 0;\n}\n\n.workspace-toggle-row > span,\n.workspace-toggle-row small {\n  display: block;\n}\n\n.workspace-toggle-row small {\n  margin-top: 0.2rem;\n  color: var(--secondary-text-color);\n  font-size: 0.8rem;\n}\n\n.workspace-toggle-row input[type='checkbox'] {\n  width: 1.1rem;\n  height: 1.1rem;\n  margin: 0;\n}\n\n.workspace-range-matrix {\n  border-top: 1px solid var(--border-color);\n}\n\n.workspace-range-row,\n.workspace-gpu-row,\n.workspace-request-options,\n.workspace-resource-readout {\n  padding: 0.75rem 0;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.workspace-range-row {\n  display: grid;\n  grid-template-columns: minmax(10rem, 0.42fr) minmax(12rem, 1fr);\n  align-items: center;\n  gap: 1rem;\n  min-width: 0;\n}\n\n.workspace-range-row > * {\n  min-width: 0;\n}\n\n/* Native range inputs have a browser-default preferred width that ignores\n   the grid track's percentage sizing, which overflows the card at dock\n   width (~360-380px). Force it to fill and shrink with its column. */\n.workspace-approval-card input[type='range'] {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  min-width: 0;\n}\n\n.workspace-range-heading label,\n.workspace-range-heading output {\n  margin: 0;\n  font-size: 0.875rem;\n}\n\n.workspace-range-heading output,\n.workspace-resource-readout strong,\n.workspace-quote dd {\n  font-variant-numeric: tabular-nums;\n}\n\n.workspace-range-row input[type='range'] {\n  min-height: 1.5rem;\n  padding: 0;\n  accent-color: var(--button-primary-bg);\n  background: transparent;\n}\n\n.workspace-gpu-row {\n  display: grid;\n  grid-template-columns: minmax(10rem, 1fr) auto;\n  align-items: center;\n  gap: 1rem;\n}\n\n.workspace-toggle-row-compact {\n  margin: 0;\n}\n\n.workspace-stepper,\n.workspace-select-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin: 0;\n  font-size: 0.875rem;\n}\n\n.workspace-stepper input {\n  width: 5rem;\n}\n\n.workspace-select-row select {\n  width: auto;\n  min-width: 10rem;\n}\n\n.workspace-request-options {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.workspace-approval-eyebrow {\n  display: block;\n  margin-bottom: 0.2rem;\n  color: var(--secondary-text-color);\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.workspace-quote {\n  margin-top: 1rem;\n  padding: 0.75rem;\n  border-radius: var(--radius-sm);\n  background: var(--card-background);\n}\n\n.workspace-quote-total strong {\n  font-size: 0.9rem;\n}\n\n.workspace-quote dl {\n  display: grid;\n  gap: 0.25rem;\n  margin: 0.6rem 0 0;\n}\n\n.workspace-quote dl div {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  color: var(--secondary-text-color);\n  font-size: 0.8rem;\n}\n\n.workspace-quote dt {\n  text-transform: capitalize;\n}\n\n.workspace-quote dd {\n  margin: 0;\n}\n\n.workspace-idle-note,\n.workspace-save-note,\n.workspace-resource-notice,\n.workspace-resource-error {\n  margin: 0.75rem 0 0;\n  color: var(--secondary-text-color);\n  font-size: 0.8rem;\n}\n\n.workspace-resource-error {\n  color: #b00020;\n}\n\n.workspace-approval-card .workspace-resource-error {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.workspace-approval-card .workspace-retry-button {\n  width: auto;\n  margin: 0;\n  flex: 0 0 auto;\n}\n\n.workspace-approval-actions,\n.workspace-summary-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin-top: 1rem;\n}\n\n.workspace-approval-actions button,\n.workspace-summary-actions button {\n  width: auto;\n  margin: 0;\n}\n\n.workspace-summary-line {\n  margin: 0.75rem 0 0;\n  font-size: 0.9rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.workspace-back-button {\n  width: auto;\n  margin: 0 0 0.75rem;\n}\n\n.workspace-resource-panel :focus-visible,\n.workspace-approval-card :focus-visible {\n  outline: 3px solid rgba(37, 99, 235, 0.35);\n  outline-offset: 2px;\n}\n\n@media (max-width: 600px) {\n  .workspace-range-row {\n    grid-template-columns: 1fr;\n    gap: 0.4rem;\n  }\n\n  .workspace-gpu-row {\n    grid-template-columns: 1fr;\n  }\n\n  .workspace-approval-actions {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .workspace-approval-actions button {\n    width: 100%;\n  }\n}\n\n/* The viewport-based breakpoint above never fires when this card is embedded\n   narrow (e.g. the ~360px chat dock) inside a wide window. A container query\n   collapses the two-column rows based on the CARD's own width instead, so\n   the range inputs and option rows never overflow it regardless of the\n   surrounding viewport. */\n@container workspaceCard (max-width: 420px) {\n  .workspace-range-row,\n  .workspace-range-matrix .workspace-range-row {\n    grid-template-columns: 1fr;\n    gap: 0.4rem;\n  }\n\n  .workspace-gpu-row {\n    grid-template-columns: 1fr;\n  }\n\n  .workspace-request-options {\n    grid-template-columns: 1fr;\n  }\n\n  .workspace-stepper,\n  .workspace-select-row {\n    flex-wrap: wrap;\n  }\n\n  .workspace-select-row select {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .workspace-stepper input {\n    width: 100%;\n  }\n\n  .workspace-approval-actions {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .workspace-approval-actions button {\n    width: 100%;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .workspace-resource-panel *,\n  .workspace-approval-card * {\n    scroll-behavior: auto;\n    transition-duration: 0.01ms !important;\n  }\n}\n.workspace-decision-note {\n  display: grid;\n  gap: 5px;\n  margin-top: 14px;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n.workspace-decision-note textarea {\n  min-height: 62px;\n  resize: vertical;\n  border: 1px solid var(--border-color, #ccc);\n  border-radius: 7px;\n  padding: 8px;\n  color: inherit;\n  background: var(--input-bg, transparent);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
